<template>
    <v-container>
        <v-card class="pa-16">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card-title class="text-h5">Progress Status</v-card-title>
                </v-col>
                <v-col align="right" color="primary" cols="12" md="6">
                    <v-btn @click="opendialogAdd" color="#0A7EA5" rounded dark class="mb-2">
                        <span>Add</span>
                        <v-icon small center>add</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field class="widthsizesearch" v-model="search" append-icon="mdi-magnify" label="Search"
                        single-line hide-details outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-end mb-6">
                </v-col>
            </v-row>

            <br />

            <v-card outlined tile class="mt-2">
                <v-col align="right" color="primary" cols="12" md="12" class="mt-n10">
                    <v-btn color="#0A7EA5" outlined rounded dark @click="openMdiIcon">
                        <span>Open Icon Search</span>
                        <v-icon small center>add</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" md="12">
                    <v-data-table dense :search="search" :headers="headers" :items="mDataArray"
                        class="elevation-1   595959">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon :style="{
                                backgroundColor: '#E1F5FE',
                                color: '#254E58',
                            }" @click="openeditItem(item)">
                                mdi-pencil
                            </v-icon>

                        </template>
                        <!-- STATUS -->
                        <template v-slot:[`item.status`]="{ item }">
                            <div class="font-weight-medium">
                                {{ item.status }}
                            </div>
                        </template>

                        <!-- COLOR PREVIEW -->
                        <template v-slot:[`item.color`]="{ item }">
                            <div class="d-flex align-center">

                                <div v-if="item.color" :style="{
                                    width: '22px',
                                    height: '22px',
                                    backgroundColor: item.color,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginRight: '8px'
                                }"></div>

                                <span>{{ item.color }}</span>

                            </div>
                        </template>

                        <!-- ICON PREVIEW -->
                        <template v-slot:[`item.icon`]="{ item }">
                            <div class="d-flex align-center">

                                <v-icon v-if="item.icon" :color="item.icon_color || '#000'" small class="mr-2">
                                    {{ item.icon }}
                                </v-icon>

                                <span>{{ item.icon }}</span>

                            </div>
                        </template>

                        <!-- ICON COLOR PREVIEW -->
                        <template v-slot:[`item.icon_color`]="{ item }">
                            <div class="d-flex align-center">

                                <div v-if="item.icon_color" :style="{
                                    width: '22px',
                                    height: '22px',
                                    backgroundColor: item.icon_color,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    marginRight: '8px'
                                }"></div>

                                <span>{{ item.icon_color }}</span>

                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-card>
        </v-card>
        <v-dialog v-model="dialogAddData" max-width="500px">
            <v-card>
                <br />
                <v-card-title class="text-h6">Internal Progress Status</v-card-title>
                <v-card-text>
                    <v-container>

                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <h3>Status</h3>
                                <v-text-field ref="Code" v-model="dataItem.status" outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="10" md="10">
                                <h3>Color</h3>

                                <v-text-field v-model="dataItem.color" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="2" md="2" class="d-flex justify-center align-center">
                                <div v-if="dataItem.color" :style="{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: dataItem.color,
                                    border: '1px solid #ccc',
                                    borderRadius: '8px'
                                }"></div>

                                <span v-else class="grey--text text-caption">
                                    Invalid
                                </span>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="10" md="10">
                                <h3>Icon</h3>

                                <v-text-field v-model="dataItem.icon" outlined dense @blur="onBlurIcon"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="2" md="2" class="d-flex justify-center align-center">
                                <template v-if="dataItem.icon">
                                    <v-icon :color="dataItem.icon_color || '#000'" size="40">
                                        {{ dataItem.icon }}
                                    </v-icon>
                                </template>

                                <span v-else class="grey--text text-caption">
                                    Invalid
                                </span>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="10" md="10">
                                <h3>Icon Color</h3>

                                <v-text-field v-model="dataItem.icon_color" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="2" md="2" class="d-flex justify-center align-center">
                                <div v-if="dataItem.icon_color" :style="{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: dataItem.icon_color,
                                    border: '1px solid #ccc',
                                    borderRadius: '8px'
                                }"></div>

                                <span v-else class="grey--text text-caption">
                                    Invalid
                                </span>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveaddItem()">
                        Save
                    </v-btn>
                    <v-btn depressed outlined width="100" @click="closeaddItem()">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <br />
            </v-card>
        </v-dialog>

        <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

        <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
            :link="link" />
    </v-container>
</template>


<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";

export default {
    name: "clientTimeLineStatus",
    data(vm) {
        return {
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            id_del: 0,
            search: "",
            leave_type: "",
            dialogDelete: false,
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,
            toggleEnable: false,
            selectstatus: "",
            mDataArray: [],
            authorize: [],
            headers: [

                {
                    text: "",
                    value: "actions",
                    align: "center",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                },
                {
                    text: "Status",
                    value: "status",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Color",
                    value: "color",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Icon",
                    value: "icon",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Icon Color",
                    value: "icon_color",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },

            ],
            dialogAddData: false,
            dataItem: {},
            modeActions: "",
        };
    },
    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
    beforeUpdate() { },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
        itemsForSelected() {
            if (this.search.length) {
                return this.dataSource.filter((item) => this.search.includes(item));
            }
            return this.dataSource;
        },
    },
    async mounted() {
        // await api.checkVersion();
        // this.userId = localStorage.getItem(server.USER_ID);
        // let yourUrlString = window.location;

        // let parser = document.createElement("a");
        // parser.href = yourUrlString;

        // this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

        // // alert("authorize_id:" + this.authorize_id);
        // if (this.authorize_id == null || this.authorize_id == 0) {
        //     // this.$router.push("/login");
        //     this.$store.state.global_dialog = true;
        //     this.setupAlertDialog(
        //         true,
        //         "Authorize Failed!!!",
        //         "Please Logout And Login Again!!!",
        //         "text-h5 red--text text-center"
        //     );
        //     this.$router.back();
        // }

        // const router_path = parser.pathname.replace("/", "");

        // const res_auth = await api.getAuthorize(this.userId, router_path);


        // this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
        // this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
        // this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
        // this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;



        // if (!this.authorize_view) {
        //     this.$router.back();
        // }

        // // ----------------- Check Authorize ---------------------------

        // let comp_id = localStorage.getItem(server.COMPANYID);

        // this.userId = localStorage.getItem(server.USER_ID);
        // if (this.userId && api.isLoggedIn()) {
        //     // this.$router.push("/");
        // } else {
        //     this.$store.state.isLogged = false;
        //     this.$router.push("/login");
        // }

        //load data
        try {
            await this.loaddata();
        } catch (err) {
            alert("error")
            console.error(err);
        } finally {
            this.$hideLoader();
        }


    },
    methods: {
        onBlurIcon() {
            if (
                this.dataItem.icon &&
                !this.dataItem.icon.startsWith("mdi-")
            ) {
                this.dataItem.icon = `mdi-${this.dataItem.icon}`;
            }
        },
        async loaddata() {
            const result = await api.getClientTimelineStatus()

            if (result.data && result.data.length > 0) {
                this.mDataArray = result.data
            }
        },
        openMdiIcon() {
            window.open(
                "https://mdi.bessarabov.com/search",
                "_blank"
            );
        },
        opendialogAdd() {
            this.modeActions = "New"
            this.dataItem = {};
            this.dialogAddData = true;
        },
        closeaddItem() {
            this.dataItem = {};
            this.dialogAddData = false;
        },

        openeditItem(data) {
            this.modeActions = "Edit";

            this.dataItem = { ...data };

            this.dialogAddData = true;
        },
        async saveaddItem() {

            // validate status
            if (!this.dataItem.status || !this.dataItem.status.trim()) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Status",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // validate color
            const isValidColor = CSS.supports("color", this.dataItem.color);

            if (!this.dataItem.color || !isValidColor) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Invalid Color Code",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // validate icon color
            const isValidIconColor = CSS.supports("color", this.dataItem.icon_color);

            if (!this.dataItem.icon_color || !isValidIconColor) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Invalid Icon Color Code",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // validate icon
            if (!this.dataItem.icon || !this.dataItem.icon.startsWith("mdi-")) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Invalid MDI Icon",
                    "text-h5 red--text text-center"
                );

                return;
            }

            try {

                this.$showLoader();

                let data = null;

                if (this.modeActions == "New") {

                    const response = await api.createClientTimelineStatus(this.dataItem);

                    data = response.data;

                } else {

                    const { id, ...payload } = this.dataItem;

                    const response = await api.updateClientTimelineStatus(
                        id,
                        payload
                    );

                    data = response.data;
                }

                if (data.success) {

                    this.closeaddItem();

                    this.$store.state.global_dialog = true;

                    this.setupAlertDialog(
                        true,
                        "Success",
                        "Saved successfully",
                        "text-h5 green--text text-center"
                    );

                    await this.loaddata();
                }



            } catch (err) {

                console.error(err);

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Cannot save data",
                    "text-h5 red--text text-center"
                );

            } finally {

                this.$hideLoader();

            }
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },

    },
};
</script>

<style scoped>
.bg-colorth {
    background-color: #595959;
    color: red;
}

.text-left {
    color: aliceblue;
}

.widthsizesearch {
    width: 70%;
}

.theme--light.v-card {
    border-color: white;
}
</style>